export default "__VITE_ASSET__DsACnXGT__"